export interface BaseTableColumns {
    id: number;
    date: string;
    number: number;
}

export class EServiceTableColumns implements BaseTableColumns {
    constructor(
        public id: number,
        public number: number,
        public requester: string,
        public date: string,
        public mainType: string,
        public subType: string,
        public status: string,
        public priority: string,
        public creationDate: string,
        public ownerName: string,
        public departmentName: string
    ) {}
}

export class EServiceHistoryFeildsTableColumns {
    constructor(
        public id: number,
        public fieldName: string,
        public oldFeild: string,
        public newFeild: string,
        public userId: string,
        public userName: string,
        public date: string,
        public fieldType: string,
        public fieldAction: string
    ) {}
}
